import layout from '@/layouts/link-block.vue'
// import importAllImages from '@/functions/importAllImages.js'

import iconiTunes from '@/content/logos/itunes.png'
import iconGoogle from '@/content/logos/google.png'
import iconSpotify from '@/content/logos/spotify.png'
import display from '@/content/display/display.png'

export default {
  version: '1.0.0',
  layout,
  showDump: false,
  custom: {},

  // !! WARNING !!
  // This function imports all images, regardless of whether they are used or not
  // be sure to move unused images to a different location
  // allImages: importAllImages(require.context('../images', false, /\.js/)),

  header: {
    title: 'Newsroom podcast',
    // intro: 'From The Newsroom talks to editors and journalists from Australia\'s number one news website news.com.au. Every morning we bring you breaking news, but also go behind the big stories of the day, give insight and delve into any rumours. We go from politics to pop culture in under five minutes. You can sign up for free here:',
    message: 'Your glimpse inside today\’s headlines',
    display,
  },

  parts: [
    {
      title: 'iTunes',
      subtitle: false,
      link: 'https://itunes.apple.com/au/podcast/from-the-newsroom/id1419274649',
      icon: iconiTunes,
    },
    {
      title: 'Google',
      subtitle: false,
      link: 'https://www.google.com/podcasts?feed=aHR0cHM6Ly9yc3Mud2hvb3Noa2FhLmNvbS9yc3MvcG9kY2FzdC9pZC8zOTI0',
      icon: iconGoogle,
    },
    {
      title: 'Spotify',
      subtitle: false,
      link: 'https://open.spotify.com/show/5JIrNU670HPQnueGJeSx04',
      icon: iconSpotify,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/content/projects/0920-newsroom-podcast-links.js